import { PropType, defineComponent } from "vue";
import moment from "moment";
import { saveNote, updateNote, deleteNote } from "@/store/note/actions";
import { DictionaryTableNote, SdkTableColumnNote } from "@/interfaces/sdk-dictionary";
import { EventBus } from "@/utils/event-bus";

export default defineComponent({
  name: "sdk-modal-note",
  props: {
    owner: String,
    tableName: String,
    columnName: String,
    note: {
      type: Object as PropType<SdkTableColumnNote>,
      required: true,
    },
    deleteNotes: {
      type: Array as PropType<DictionaryTableNote[]>,
    },
    createdNotes: {
      type: Array as PropType<DictionaryTableNote[]>,
    },
  },
  data() {
    return {
      editionContent: "",
      readMore: false,
      editMode: false,
      nota: "" as any,
    };
  },
  computed: {
    getReadMore(): boolean {
      return this.readMore;
    },
    getEditMode(): boolean {
      return this.editMode;
    },
    timeStamp(): string {
      return `${this.note.lastChange ? moment(this.note.lastChange).format("DD/MM/YYYY") : "Sem data"}`;
    },
  },
  methods: {
    toggleReadMore(): void {
      this.readMore = !this.readMore;
    },
    toggleEditMode(): void {
      this.editMode = !this.editMode;
      if (this.getReadMore) {
        this.toggleReadMore();
      }
      if (this.getEditMode) {
        this.editionContent = this.note.note;
      }
    },
    async confirmEdition() {
      // eslint-disable-next-line vue/no-mutating-props
      this.note.note = this.editionContent;
      if (!this.note.id) {
        await this.$dispatch(saveNote)([this.note], this.$t("modal.msgSave")).then((data: any) => {
          EventBus.$emit("new-note-child", { note: data, placeholder: this.note });
        });
      } else {
        await this.$dispatch(updateNote)([this.note], this.$t("modal.msgUpdate"));
      }
      this.toggleEditMode();
    },
    editOnCreate() {
      EventBus.$on("edit-note", (newNote: SdkTableColumnNote) => {
        if (this.note === newNote) {
          this.editMode = true;
        }
      });
    },
    async deleteNote() {
      if (this.note.id) {
        await this.$dispatch(deleteNote)([this.note], this.$t("modal.msgDelete"));
        EventBus.$emit("remove-child-note", this.note);
      } else {
        EventBus.$emit("remove-child-note", this.note);
      }
    },
  },
  mounted() {
    this.nota = this.$t("modal.placeholder");
    this.editOnCreate();
    EventBus.$emit("on-note-ready", true);
  },
  beforeDestroy() {
    EventBus.$off("edit-note");
  },
});
